import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";
import moment from "moment";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import { useGlobalState } from "../Context/GlobalStateContext";
import * as XLSX from "xlsx";
import MainTopFilters from "../App/MainTopFilters";
import Confirmation from "../App/Confirmation";
import LockUnlock from "../App/LockUnlock";
import { getAccessSettings } from "../Shared/Utility";
function DeadlineManagement() {
  const globalState = useGlobalState();

  const [showAnimation, setShowAnimation] = useState(false);
  const [locked, setLocked] = useState(true);

  const [showExportDropdown, setShowExportDropdown] = useState(false);
  const [screenID, setScreenID] = useState(0);

  const [copyToAllObj, setCopyToAllObj] = useState({
    PID: 0,
    Value: "",
    DateType: 0,
  });

  const [ibbProgramId, setIBBProgramId] = useState(0);
  const [IBBDeadlineListsData, setIBBDeadlineListsData] = useState<any>([]);
  const [IBBDeadlineData, setIBBDeadlineData] = useState<any>([]);

  useEffect(() => {
    getDeadlineListsData();
  }, []);

  useEffect(() => {
    if (ibbProgramId > 0) getIBBDeadlineData();
  }, [ibbProgramId]);

  const exportRef = useRef<any>(null);
  useEffect(() => {
    // Function to handle outside clicks
    const handleClickOutside = (event: any) => {
      // Check if the click target is outside the component's DOM node
      if (exportRef.current && !exportRef.current.contains(event.target)) {
        setShowExportDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  function getDeadlineListsData() {
    setShowAnimation(true);
    let object = {} as any;
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBDeadlineData/GetDeadlineListsData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setIBBProgramId(l_response[0][0].IBBProgramID);
          setIBBDeadlineListsData(l_response);
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getIBBDeadlineData() {
    setShowAnimation(true);
    let object = {} as any;
    object.ibbprogramid = ibbProgramId;
    debugger;
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBDeadlineData/GetDeadlineData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setIBBDeadlineData(l_response);
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  // Download in Excel function
  function DownloadClientsDataInExcel(id: any, name: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      document.getElementById(id)
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, name);
    /* save to file */
    XLSX.writeFile(wb, name + ".xlsx");
  }

  function updateValue(
    ColumnNames: any,
    PID: any,
    Value: any,
    DateType: any,
    Quarter: any,
    CopyToAll: any
  ) {
    let l_GridData: any = [...IBBDeadlineData];
    for (let i = 0; i < l_GridData[0].length; i++) {
      if (l_GridData[0][i].PID === PID) {
        l_GridData[0][i][ColumnNames] = Value;
        break;
      }
    }
    setIBBDeadlineData(l_GridData);

    saveIBBDeadlineData(PID, Value, DateType, Quarter, CopyToAll);
  }

  function saveIBBDeadlineData(
    PID: any,
    Value: any,
    DateType: any,
    Quarter: any,
    CopyToAll: any
  ) {
    let object = {} as any;
    object.sc = screenID;
    object.ibbprogramid = ibbProgramId;
    object.pid = PID;
    object.deadline = Value;
    object.datetype = DateType;
    object.quarter = Quarter;
    object.copyToall = CopyToAll;
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBDeadlineData/SetDeadlineData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (CopyToAll == 1) getIBBDeadlineData();
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function showConfirmation(
    PID: any,
    Value: any,
    DateType: any,
    CopyToAll: any
  ) {
    copyToAllObj.PID = PID;
    copyToAllObj.Value = Value;
    copyToAllObj.DateType = DateType;
    globalState.setConfirmationObject({
      ShowPopup: true,
      Heading: "Confirmation",
      Message: "Are you sure you want to copy to all importer.",
      ID: 1,
    });
  }

  // function ConfirmationCallBack(obj: any) {
  //   if (obj.ID === 1) {
  //     if (obj.isConfirm === true) {
  //       saveIBBDeadlineData(
  //         copyToAllObj.PID,
  //         copyToAllObj.Value,
  //         copyToAllObj.DateType,
  //         1
  //       );
  //     }
  //   }

  //   globalState.setConfirmationObject({
  //     ShowPopup: false,
  //     Heading: "",
  //     Message: "",
  //     ID: 0,
  //   });
  // }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      {/* <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      /> */}
      <div className="page--contents">
        <div className="page--breadcrumb">
          {/* <a className="f-child">Admin</a>
          <span>{">"}</span> */}
          <a>Deadline Management</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items justify-btw">
              <div className="centre-drop-cl">
                <select
                  className="input-field select-field"
                  value={ibbProgramId}
                  onChange={(e: any) => setIBBProgramId(e.target.value)}
                >
                  {IBBDeadlineListsData[0] &&
                    IBBDeadlineListsData[0].map((Item: any, index: any) => (
                      <option
                        value={Item.IBBProgramID}
                        key={"IBBProgramID" + Item.IBBProgramID}
                      >
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="flex-items flex-33 justify-end">
              {/* <div className="btn-d-toggle" ref={exportRef}>
                <a
                  className="btn-primary"
                  title="Export data"
                  onClick={() => setShowExportDropdown(!showExportDropdown)}
                >
                  <img
                    src="images/download.svg"
                    width="13px"
                    height="15px"
                    alt="download"
                  />
                </a>
              </div> */}

              {getAccessSettings(2, 25) > 1 && (
                <LockUnlock locked={locked} setLocked={setLocked} />
              )}
                          <a
                className="btn-primary"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tbldeadlinemanagement", "DeadLineManagement")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>

          </div>

          <>
            <div className="section-table scroll-table uv-vol dark-back courtesy-table deadline-table pad-all0">
              <table className="part-head trend-table w-fs">
                <thead>
                  <tr>
                    <th className="w-min">Stage</th>
                    <th className="w-min">Q1</th>
                    <th className="w-min">Q2</th>
                    <th className="w-min">Q3</th>
                    <th className="w-min">Q4</th>
                  </tr>
                </thead>
                <tbody>
                  {IBBDeadlineData[0] &&
                    IBBDeadlineData[0].map((Item: any, Index: any) => (
                      <React.Fragment key={"Index" + Index}>
                        <tr>
                          <td>{Item.Stage}</td>
                          <td>
                            <div className="flex-items">
                              <input
                                disabled={locked}
                                type="datetime-local"
                                value={Item.Q1DeadlineSubmission}
                                onChange={(e) =>
                                  updateValue(
                                    "Q1DeadlineSubmission",
                                    Item.PID,
                                    e.target.value,
                                    1,
                                    1,
                                    0
                                  )
                                }
                              ></input>
                              
                              {/* <a
                                title="Copy to all importer"
                                onClick={() =>
                                  showConfirmation(
                                    Item.PID,
                                    Item.Q1DeadlineSubmission,
                                    1,
                                    1
                                  )
                                }
                              >
                                <img
                                  src="images/copy-b.svg"
                                  width={15}
                                  height={15}
                                />
                              </a> */}
                            </div>
                          </td>
                          <td>
                            <div className="flex-items">
                              <input
                                disabled={locked}
                                type="datetime-local"
                                value={Item.Q2DeadlineSubmission}
                                onChange={(e) =>
                                  updateValue(
                                    "Q2DeadlineSubmission",
                                    Item.PID,
                                    e.target.value,
                                    1,
                                    2,
                                    0
                                  )
                                }
                              ></input>
                              {/* <a
                                title="Copy to all importer"
                                onClick={() =>
                                  showConfirmation(
                                    Item.PID,
                                    Item.Q1DeadlineSubmission,
                                    1,
                                    1
                                  )
                                }
                              >
                                <img
                                  src="images/copy-b.svg"
                                  width={15}
                                  height={15}
                                />
                              </a> */}
                            </div>
                          </td>
                          <td>
                            <div className="flex-items">
                              <input
                                disabled={locked}
                                type="datetime-local"
                                value={Item.Q3DeadlineSubmission}
                                onChange={(e) =>
                                  updateValue(
                                    "Q3DeadlineSubmission",
                                    Item.PID,
                                    e.target.value,
                                    1,
                                    3,
                                    0
                                  )
                                }
                              ></input>
                              {/* <a
                                title="Copy to all importer"
                                onClick={() =>
                                  showConfirmation(
                                    Item.PID,
                                    Item.Q1DeadlineSubmission,
                                    1,
                                    1
                                  )
                                }
                              >
                                <img
                                  src="images/copy-b.svg"
                                  width={15}
                                  height={15}
                                />
                              </a> */}
                            </div>
                          </td>
                          <td>
                            <div className="flex-items">
                              <input
                                disabled={locked}
                                type="datetime-local"
                                value={Item.Q4DeadlineSubmission}
                                onChange={(e) =>
                                  updateValue(
                                    "Q4DeadlineSubmission",
                                    Item.PID,
                                    e.target.value,
                                    1,
                                    4,
                                    0
                                  )
                                }
                              ></input>
                              {/* <a
                                title="Copy to all importer"
                                onClick={() =>
                                  showConfirmation(
                                    Item.PID,
                                    Item.Q1DeadlineSubmission,
                                    1,
                                    1
                                  )
                                }
                              >
                                <img
                                  src="images/copy-b.svg"
                                  width={15}
                                  height={15}
                                />
                              </a> */}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
              <table className="part-head trend-table w-fs no-display" id="tbldeadlinemanagement">
                <thead>
                  <tr>
                    <th className="w-min">Stage</th>
                    <th className="w-min">Q1</th>
                    <th className="w-min">Q2</th>
                    <th className="w-min">Q3</th>
                    <th className="w-min">Q4</th>
                  </tr>
                </thead>
                <tbody>
                  {IBBDeadlineData[0] &&
                    IBBDeadlineData[0].map((Item: any, Index: any) => (
                      <React.Fragment key={"Index" + Index}>
                        <tr>
                          <td>{Item.Stage}</td>
                          <td>
                            <div className="flex-items">
                              {/* <input
                                disabled={locked}
                                type="datetime-local"
                                value={Item.Q1DeadlineSubmission}
                                onChange={(e) =>
                                  updateValue(
                                    "Q1DeadlineSubmission",
                                    Item.PID,
                                    e.target.value,
                                    1,
                                    1,
                                    0
                                  )
                                }
                              ></input> */}
                              <span>{Item.Q1DeadlineSubmission}</span>
                              
                              {/* <a
                                title="Copy to all importer"
                                onClick={() =>
                                  showConfirmation(
                                    Item.PID,
                                    Item.Q1DeadlineSubmission,
                                    1,
                                    1
                                  )
                                }
                              >
                                <img
                                  src="images/copy-b.svg"
                                  width={15}
                                  height={15}
                                />
                              </a> */}
                            </div>
                          </td>
                          <td>
                            <div className="flex-items">
                            <span>{Item.Q2DeadlineSubmission}</span>
                              {/* <a
                                title="Copy to all importer"
                                onClick={() =>
                                  showConfirmation(
                                    Item.PID,
                                    Item.Q1DeadlineSubmission,
                                    1,
                                    1
                                  )
                                }
                              >
                                <img
                                  src="images/copy-b.svg"
                                  width={15}
                                  height={15}
                                />
                              </a> */}
                            </div>
                          </td>
                          <td>
                            <div className="flex-items">
                            <span>{Item.Q3DeadlineSubmission}</span>
                              {/* <a
                                title="Copy to all importer"
                                onClick={() =>
                                  showConfirmation(
                                    Item.PID,
                                    Item.Q1DeadlineSubmission,
                                    1,
                                    1
                                  )
                                }
                              >
                                <img
                                  src="images/copy-b.svg"
                                  width={15}
                                  height={15}
                                />
                              </a> */}
                            </div>
                          </td>
                          <td>
                            <div className="flex-items">
                            <span>{Item.Q4DeadlineSubmission}</span>
                              {/* <a
                                title="Copy to all importer"
                                onClick={() =>
                                  showConfirmation(
                                    Item.PID,
                                    Item.Q1DeadlineSubmission,
                                    1,
                                    1
                                  )
                                }
                              >
                                <img
                                  src="images/copy-b.svg"
                                  width={15}
                                  height={15}
                                />
                              </a> */}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        </div>
      </div>
    </>
  );
}

export default DeadlineManagement;
